import OutlineButton from "../buttons/outline_button";
import HeaderLogo from "../logo/header_logo";
import NavigationBar from "../navigation/navigation_bar";
import {DETECT_PAGE} from "../../config/router/router";

export function Header() {
    return (
        <header className={"fixed w-screen h-16 bg-transparent px-4 py-2 flex items-center"}>
            <div className={"w-1/12"}>
                <HeaderLogo/>
            </div>
            <div className={"hidden sm:flex flex-row justify-between items-center w-11/12"}>
                <NavigationBar/>
                <OutlineButton name={"Detect DF"} to={DETECT_PAGE}/>
            </div>
        </header>
    );
}